import { ref, withParams } from 'vuelidate/lib/validators/common';
import { removeAMPM } from '@/js/FormFunctions';
import moment from 'moment';

export default timeGreaterThan => withParams(
  { type: 'timeGreaterThan', eq: timeGreaterThan },
  function (value, parentVm) {
    const other = ref(timeGreaterThan, this, parentVm);

    // workstartdate is for revisions, start date is for permits
    if (this.form.workStartDate && this.form.workEndDate) {
      const startMoment = moment(this.form.workStartDate);
      const endMoment = moment(this.form.workEndDate);
      if (!startMoment.isSame(endMoment)) {
        return true;
      }
    } else if (this.form.startDate && this.form.endDate) {
      const startMoment = moment(this.form.startDate);
      const endMoment = moment(this.form.endDate);
      if (!startMoment.isSame(endMoment)) {
        return true;
      }
    }

    const strippedValue = removeAMPM(value);
    const strippedOther = removeAMPM(other);

    if (!other || !value || !strippedValue || !strippedOther) {
      return false;
    }

    let otherHours = strippedOther.split(':')[0];
    let valueHours = strippedValue.split(':')[0];

    const otherMinutes = strippedOther.split(':')[1];
    const valueMinutes = strippedValue.split(':')[1];

    const otherAMPM = other.slice(-2);
    const valueAMPM = value.slice(-2);

    if (otherHours === 12) {
      otherHours = -1;
    }

    if (valueHours === 12) {
      valueHours = -1;
    }

    if (!otherHours || !otherAMPM || !valueHours || !valueAMPM) {
      return true;
    }

    if (valueAMPM === 'PM' && otherAMPM === 'AM') {
      return true;
    }

    if (valueAMPM === 'AM' && otherAMPM === 'PM') {
      return false;
    }

    if (valueHours !== otherHours) {
      return valueHours > otherHours;
    }

    return valueMinutes > otherMinutes;
  },
);
